module.exports = __webpack_public_path__ + "img/italy.ea0a8bd5.svg";